import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzVday65 } from './pages'

type TIdToPageMapWoofzVday65 = Record<PageIdWoofzVday65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_VDAY_65: TIdToPageMapWoofzVday65 = {
  [PageId.SUBSCRIPTIONS_VDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/subscriptions/SubscriptionVday65'
      ).then((m) => ({
        default: m.SubscriptionsVday65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/subscriptions/SubscriptionVday65'
      ),
  },
  [PageId.CHAT_UPSELL_VDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_VDAY_65]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vday/woofz_vday_65/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vday/woofz_vday_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzVday65.DOWNLOAD_VDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzVday65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
